/* eslint-disable camelcase */
import { createSelector } from 'reselect';
import configSelector from './config';

const selectPayloadByKey = createSelector(
  (state) => state.wildcard.payload,
  (_, key) => key,
  (payload, key) => payload[key],
);

export default createSelector(selectPayloadByKey, configSelector, (payload) => {
  if (!payload || !payload.data) return { ...payload, payload: [], haveMore: false };

  const {
    isWaiting,
    data: {
      aggregations: {
        results: { sum_other_doc_count, buckets },
      },
    },
  } = payload;

  const result = buckets
    .map((bucket) => {
      const key = JSON.stringify(bucket.key);

      return {
        key,
        label: bucket.key,
      };
    })
    .sort((a, b) => {
      const textA = a.label.toUpperCase();
      const textB = b.label.toUpperCase();

      // eslint-disable-next-line no-nested-ternary
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

  const haveMore = sum_other_doc_count > 0;

  return { isWaiting, payload: result, haveMore };
});
